import React, { FC, ReactElement, ReactNode } from 'react';

import css from './style.module.scss';
import setQaAttribute from '../../../helpers/setQaAttribute';

interface IProps {
  children: ReactElement | ReactElement[] | ReactNode;
  qaId?: string;
}

const ArticleBlockMain: FC<IProps> = ({ children, qaId }) => {
  return (
    <main className={css.articleBlock__main} {...setQaAttribute(qaId)}>
      {children}
    </main>
  );
};

export default ArticleBlockMain;
